import { Delete, MoreVert } from '@material-ui/icons'
import axios from 'axios'
import React, { useState } from 'react'
import { useEffect } from 'react'
import { useContext } from 'react'
import { useParams } from 'react-router-dom'
import { AuthContext } from '../../context/AuthContext'
import ENDPOINT from '../../context/EndPoint'
import SecurityHeaders from '../../context/SecurityHeaders'
import { Dropdown } from 'react-bootstrap';
import { Chip } from '@mui/material'
import DetectDevice from '../../context/DetectDevice'
import { useDispatch } from 'react-redux'
const ResourceManagement = () => {
  const dispatch = useDispatch()
const device = DetectDevice()
    const [title,settitle] = useState(null)
    const params = useParams()
    const course_url = params.course_url
    const [description,setdescription] = useState(null)
    const [type,settype] = useState("link")
    const [url,seturl] = useState(null)
const {user} = useContext(AuthContext)

const AddResource = async (e) => {
  dispatch({ type: 'LOADING' });

  try {
    e.preventDefault();
    const data = new FormData();
    data.append("title", title);
    data.append("description", description);
    data.append("type", type);
    data.append("link", url);
    data.append("course_url", course_url);
    data.append("session", user.SessionId);

    const res = await axios.post(
      ENDPOINT + "admin-add-course-resource.php",
      data,
      SecurityHeaders
    );

    if (res) {
      if (res.data.status === "success") {
        dispatch({ type: 'DONE_LOADING' });
        GetResources(); // Assuming this is a defined function to fetch resources
      } else {
        dispatch({ 
          type: 'ERROR', 
          payload: res.data.message || 'Failed to add resource' 
        });
      }
    }
  } catch (error) {
    dispatch({ 
      type: 'ERROR', 
      payload: error.message || 'An error occurred while adding resource' 
    });
  }
};

const [resources,setresources] = useState(null)

const GetResources = async () => {
  dispatch({ type: 'LOADING' });

  const data = new FormData();
  data.append("course_url", course_url);
  data.append("session", user.SessionId);

  try {
    const res = await axios.post(
      ENDPOINT + "admin-get-resources.php",
      data,
      SecurityHeaders
    );

    if (res) {
      if (res.data && res.data.status === "success") {
        dispatch({ type: 'DONE_LOADING' });
        setresources(res.data.data);
      } else {
        dispatch({ 
          type: 'ERROR', 
          payload: res.data?.message || 'Failed to fetch resources' 
        });
      }
    }
  } catch (error) {
    dispatch({ 
      type: 'ERROR', 
      payload: error.message || 'An error occurred while fetching resources' 
    });
  }
};

const DeleteResource = async ({ resource_id }) => {
  dispatch({ type: 'LOADING' });

  const data = new FormData();
  data.append("resource_id", resource_id);
  data.append("session", user.SessionId);

  try {
    const res = await axios.post(
      ENDPOINT + "admin-delete-resource.php",
      data,
      SecurityHeaders
    );

    if (res && res.data) {
      if (res.data[0]?.status === "success") { // Assuming status is nested in an array
        dispatch({ type: 'DONE_LOADING' });
        GetResources(); // Assuming this is the previously defined function
      } else {
        dispatch({ 
          type: 'ERROR', 
          payload: res.data[0]?.message || 'Failed to delete resource' 
        });
      }
    } else {
      dispatch({ 
        type: 'ERROR', 
        payload: 'Invalid response format' 
      });
    }
  } catch (error) {
    dispatch({ 
      type: 'ERROR', 
      payload: error.message || 'An error occurred while deleting resource' 
    });
  }
};
useEffect(()=>{
GetResources()
},[])

  return (
    <div>
      {device==="mobile"?
      <>

        <div className="col-lg-5 col-12 p-3">
                <h4>Add Resource</h4>
                  <form onSubmit={(e)=>AddResource(e)}>
                  <input required className="form-control mt-3" value={title} onChange={(e)=>settitle(e.target.value)} placeholder="title"></input>
                  <input required className="form-control mt-2" onChange={(e)=>setdescription(e.target.value)} placeholder="Description"></input>
                
                <select required className="form-control mt-2"  onChange={(e)=>settype(e.target.value)}>
                  <option value="pdf">PDF</option>
                  <option value="link">Link</option>
                
                </select>
                  <input required className="form-control mt-2" onChange={(e)=>seturl(e.target.value)} placeholder={type==="pdf"?type+" Link":"Resource Link"}></input>
                
                  <button className="btn btn-primary mt-4">Add resource</button>
            
                  </form>
              
                </div>
        <div className="d-flex justify-content-between align-items-center mt-1 p-3">
            <h4>Course Resources</h4>
          
        </div>
        
        <div className="mt-2">
            <div className="d-flex flex-wrap justify-content-between flex-column-reverse  flex-md-row">


              <div className="col-lg-6">
                {resources?
                <>
                  {resources.map((resource)=>(
                    <>
                  <div className="border p-3 mb-2">

                  <div className="d-flex justify-content-between">
                  <h6>{resource.title}</h6>


                  <div className="d-flex">
                    
                  <Dropdown className="options-dropdown">   
                          <Dropdown.Toggle className="bg-white options p-0 w-fit h-fit  border-0" >
                          <MoreVert className="text-dark"/>
                          </Dropdown.Toggle>
                          <Dropdown.Menu>
                          <Dropdown.Item   >Edit</Dropdown.Item>
                          <Dropdown.Item onClick={()=>DeleteResource({resource_id:resource.id})} ><Delete className='me-2' />Delete</Dropdown.Item>
                        
                            

                            </Dropdown.Menu>
                        </Dropdown>
                        
                  </div>


                  </div>
                  <hr className='mt-1 mb-0'></hr>
                  <p className='text-secondary extra-small'>{resource.description}</p>
                  <a target='_blank' href={resource.url}>View {resource.type}</a>
                  </div>

                    </>
                  ))}
                </>:
                <>


                </>}
              </div>
    
    
              </div>
            </div>
      </>:
      <>
        <div className="d-flex justify-content-between align-items-center mt-1 p-3">
            <h4>Course Resources</h4>
          
        </div>
        
        <div className="mt-2">
            <div className="d-flex flex-wrap justify-content-between flex-column-reverse flex-lg-row">


              <div className="col-lg-6 col-12 p-3">
                {resources?
                <>
                  {resources.map((resource)=>(
                    <>
                  <div className="border p-3 mb-2">

                  <div className="d-flex justify-content-between">
                  <h6>{resource.title}</h6>


                  <div className="d-flex">
                    
                  <Dropdown className="options-dropdown">   
                          <Dropdown.Toggle className="bg-white options p-0 w-fit h-fit  border-0" >
                          <MoreVert className="text-dark"/>
                          </Dropdown.Toggle>
                          <Dropdown.Menu>
                          <Dropdown.Item   >Edit</Dropdown.Item>
                          <Dropdown.Item onClick={()=>DeleteResource({resource_id:resource.id})} ><Delete className='me-2' />Delete</Dropdown.Item>
                        
                            

                            </Dropdown.Menu>
                        </Dropdown>
                        
                  </div>


                  </div>
                  <hr className='mt-1 mb-0'></hr>
                  <p className='text-secondary extra-small'>{resource.description}</p>
                  <a target='_blank' href={resource.url}>View {resource.type}</a>
                  </div>

                    </>
                  ))}
                </>:
                <>


                </>}
              </div>
    
    
              <div className="col-lg-5 col-12 p-3">
                <h4>Add Resource</h4>
                  <form onSubmit={(e)=>AddResource(e)}>
                  <input required className="form-control mt-3" value={title} onChange={(e)=>settitle(e.target.value)} placeholder="title"></input>
                  <input required className="form-control mt-2" onChange={(e)=>setdescription(e.target.value)} placeholder="Description"></input>
                
                <select required className="form-control mt-2"  onChange={(e)=>settype(e.target.value)}>
                  <option value="pdf">PDF</option>
                  <option value="link">Link</option>
                
                </select>
                  <input required className="form-control mt-2" onChange={(e)=>seturl(e.target.value)} placeholder={type==="pdf"?type+" Link":"Resource Link"}></input>
                
                  <button className="btn btn-primary mt-4">Add resource</button>
            
                  </form>
              
                </div>
                      </div>
            </div>
      </>}
        
    </div>
  )
}

export default ResourceManagement